export default __webpack_public_path__ + "images/A0.2560698.png";